import React, { Fragment, useState, useEffect } from "react";
import { Container, Row, Col, Modal } from "react-bootstrap"; 
import { Link } from "react-router-dom"; 
import * as apiUrl from "../../apiUrl";

function OurteamLeadership() {
  const [show, setShow] = useState(false);
  const [selectedLeader, setSelectedLeader] = useState(null);
  const [LeadershipSection, setLeadershipSection] = useState({});

  useEffect(() => {
    const fetchLeadershipSection = async () => {
      try {
        const response = await fetch(
          apiUrl.apiUrl + `/api/our-team/leadership-section`
        );
        if (!response.ok) {
          throw new Error("Failed to fetch data");
        }
        const data = await response.json();
        setLeadershipSection(data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchLeadershipSection();
  }, []);

  const leaders = LeadershipSection.leaders
    ? JSON.parse(LeadershipSection.leaders)
    : [];

  const handleShow = (leader) => {
    setSelectedLeader(leader);
    setShow(true);
  };

  const handleClose = () => {
    setShow(false);
    setSelectedLeader(null);
  };

  return (
    <Fragment>
      <section className="leadership-sec">
        <Container fluid>
          <Row className="flex-center text-center mb-4">
            <Col md={12}>
              <div className="home-community-head">
                <h2 className="common-head greyColor" data-aos="fade-up">
                  {LeadershipSection.section_title}
                </h2>
              </div>
            </Col>
          </Row>
        </Container>
        <Container fluid>
          <Row className="flex-center" data-aos="fade-up">
            {leaders.map((leader, index) => (
              <Col md={4} key={index}>
                
                  <div className="leadership-card"> 
                    <img
                      src={`${apiUrl.apiUrl}/${leader.image}`}
                      className="img-fluid"
                      alt={`Marquis Real Estate Developer in Dubai`}
                    />
                    <div className="leadership-content-div">
                      <h6 className="leadership-name">{leader.name}</h6>
                      <p className="common-para">{leader.position}</p>
                     
                    </div> 
                    {/* <Link onClick={() => handleShow(leader)}>
                    <img
                      src={`${apiUrl.apiUrl}/${leader.image}`}
                      className="img-fluid"
                      alt={leader.name}
                    />
                    <div className="leadership-content-div">
                      <h6 className="leadership-name">{leader.name}</h6>
                      <p className="common-para">{leader.position}</p>
                      <div className="text-right">
                        <Link
                          onClick={() => handleShow(leader)}
                          className="marquis-roundededge-button"
                        >
                          Know More
                        </Link>
                      </div>
                    </div>
                    </Link> */}
                  </div>
                
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* Modal for selected leader */}
      {selectedLeader && (
        <Modal
          show={show}
          onHide={handleClose}
          centered
          className="ourteam-modal modal-right modal-new-right"
        >
          <div className="modal-right modal-new-right">
            <div className="">
              <Modal.Header
                closeButton
                className="modal-heading"
              ></Modal.Header>
              <Modal.Body>
                <div className="modal-ourteam-container">
                  <Container fluid>
                    <Row>
                      {/* <Col md={12}>
                      <div className="ourteam-modal-img">
                        <img
                          src={`${apiUrl.apiUrl}/${selectedLeader.image}`}
                          className="img-fluid"
                          alt={selectedLeader.name}
                        />
                      </div>
                    </Col> */}
                      <Col md={12}>
                        <div className="ourteam-modal-content">
                          <h2 className="common-head greyColor">
                            {selectedLeader.name}
                          </h2>
                          <p className="common-para">
                            {selectedLeader.position}
                          </p>
                          {/* <Link to={`mailto:${selectedLeader.email}`} className="rounded-mail-button">
                          <FaRegEnvelope /> {selectedLeader.email}
                        </Link> */}
                          {selectedLeader.section_description.map(
                            (desc, index) => (
                              <p key={index} className="common-para">
                                {desc}
                              </p>
                            )
                          )}
                        </div>
                      </Col>
                    </Row>
                  </Container>
                </div>
              </Modal.Body>
            </div>
          </div>
        </Modal>
      )}
    </Fragment>
  );
}

export default OurteamLeadership;
